import { Languages } from 'app/i18n/languages.enum';
import { axiosInstance } from 'app/pages/frames/helpers/buildFetch';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const useLocale = () => {
  const { i18n } = useTranslation();
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const locale = params.get('locale') ?? Languages.es;
    if (locale) {
      i18n.changeLanguage(locale);
    }

    const languageCode = locale.toLocaleLowerCase();
    const languageHeader = `${languageCode}-419,${languageCode};q=0.9`;
    axiosInstance.defaults.headers.common['Accept-Language'] = languageHeader;
  }, [i18n, search]);
};
